import Vue from "vue";
import App from "./App.vue";
import VueMoment from "vue-moment";
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
import VueToasted from "vue-toasted";
import "bootstrap/dist/css/bootstrap.css";
import "../node_modules/timeline-vuejs/dist/timeline-vuejs.css";
import "vue-wysiwyg/dist/vueWysiwyg.css";

import "../themeConfig.js";
// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router/index";

// Vuex Store
import store from "./store/store";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
import VueClipboard from "vue-clipboard2";
import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {
  hideModules: {
    underline: true,
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    code: true,
    link: true,
    orderedList: true,
    unorderedList: true,
    image: true,
    table: true,
    removeFormat: true,
  },
});
Vue.use(Vuesax);
Vue.use(VueClipboard);
Vue.use(VueToasted);
Vue.use(VueMoment);
Vue.use(VueHammer);

// SweetAlert2 for modern alert popups
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// axios
import axios from "axios";
import api from "./utils/api";

Vue.prototype.$http = api;

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = token.startsWith("Bearer ")
        ? token
        : `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isSessionExpiredShowing = false;

function triggerLogoutAndSessionExpiredAlert() {
  // 1. Immediately clear authentication data from localStorage
  const keys = Object.keys(localStorage);
  keys.forEach((key) => {
    if (!key.startsWith("formFilled_")) {
      localStorage.removeItem(key);
    }
  });

  // 2. Immediately redirect to login page
  if (router.currentRoute && router.currentRoute.name !== "page-login") {
    router.replace({ name: "page-login" }).catch(() => {});
  }

  // 3. Show modern SweetAlert2 popup dialog (guarded against duplicate alerts)
  if (!isSessionExpiredShowing) {
    isSessionExpiredShowing = true;
    Swal.fire({
      title: "Sesi Telah Berakhir",
      text: "Sesi Anda telah berakhir! Silakan login kembali untuk melanjutkan.",
      icon: "warning",
      confirmButtonText: "Ke Halaman Login",
      confirmButtonColor: "#7367f0",
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        confirmButton:
          "vs-component vs-button vs-button-primary vs-button-filled p-3 px-5 font-semibold",
        popup: "rounded-lg shadow-2xl",
      },
    }).then(() => {
      isSessionExpiredShowing = false;
      if (router.currentRoute && router.currentRoute.name !== "page-login") {
        router.replace({ name: "page-login" }).catch(() => {});
      }
    });
  }
}

function isSessionExpiredResponse(res) {
  if (!res) return false;

  // Do not flag failed login attempts on /auth/login as expired session
  const url = res.config && res.config.url ? res.config.url : "";
  if (url.includes("/auth/login")) {
    return false;
  }

  if (res.data) {
    const statusCode = String(res.data.status_code);
    if (statusCode === "403") return true;

    if (typeof res.data.messages === "string") {
      const msg = res.data.messages.toLowerCase();
      if (
        msg.includes("session has been expired") ||
        msg.includes("sesi anda telah berakhir") ||
        msg.includes("token expired") ||
        msg.includes("token invalid")
      ) {
        return true;
      }
    }
  }

  if (res.status === 401 || res.status === 403) {
    return true;
  }

  return false;
}

api.interceptors.response.use(
  (response) => {
    if (isSessionExpiredResponse(response)) {
      triggerLogoutAndSessionExpiredAlert();
      return Promise.reject(response);
    }
    return Promise.resolve(response);
  },
  (error) => {
    if (error && error.response && isSessionExpiredResponse(error.response)) {
      triggerLogoutAndSessionExpiredAlert();
    } else {
      console.error("API Response Error:", error);
    }
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    if (isSessionExpiredResponse(response)) {
      triggerLogoutAndSessionExpiredAlert();
      return Promise.reject(response);
    }
    return Promise.resolve(response);
  },
  (error) => {
    if (error && error.response && isSessionExpiredResponse(error.response)) {
      triggerLogoutAndSessionExpiredAlert();
    } else {
      console.error("API Response Error:", error);
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
